import { render } from "./viewPlayer.vue?vue&type=template&id=f6712a3c"
import script from "./viewPlayer.vue?vue&type=script&lang=js"
export * from "./viewPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__